import React from 'react';
import styles from "./style";
import { Navbar, Hero, Footer, Specifications, Features, VideoSection } from './components';
import AboutUs from "./components/AboutUs";
import Carrousel from "./components/Carrousel";

const App = () => {
  return (
    <div className="bg-primary w-full overflow-hidden antialiased selection:bg-secondary selection:text-primary">
      
      <header className={`${styles.paddingX} ${styles.flexCenter}`}>
        <div className={`${styles.boxWidth}`}>
          <Navbar />
        </div>
      </header>

      <main>
        <section className={`bg-primary ${styles.flexStart}`}>
          <div className={`${styles.boxWidth}`}>
            <Hero />
          </div>
        </section>

        <section className={`bg-primary ${styles.paddingX} ${styles.flexStart}`}>
          <div className={`${styles.boxWidth}`}>
            <Specifications />
            <Features />
            <VideoSection />
            <Carrousel />
            {/* Ya no está <ProjectQR /> */}
            <h2 id="aboutUs" className={styles.heading2}>
              Nuestro Equipo <br className="hidden sm:block" />
            </h2>
            <AboutUs />
            <Footer />
          </div>
        </section>
      </main>

    </div>
  );
};

export default App;